import { ReactNode } from 'react';

import { AppFormattedMessage } from '../../../../../components/app-formatted-message/index';
import { getTranslation } from '../../../../../utils/get-translation.util';
import { toUpperCaseWords } from '../../../../../utils/to-uppercase-util.util';

export type ScenarioDetailsBase = {
  columns: (ReactNode | string)[];
  columnsCount: number;
  description: ReactNode | string;
  hoverText: ReactNode | string;
  showButton: boolean;
  title: ReactNode | string;
};
export interface NewScenarioDetails extends ScenarioDetailsBase {
  addButtonText: ReactNode | string;
}

export interface ExistingScenarioDetails extends ScenarioDetailsBase {
  additionalColumns?: (ReactNode | string)[];
  additionalColumnsCount?: number;
}

export enum FundraisingScenarioKey {
  CUSTOM_SAFES = 'custom-safes',
  GRANTS = 'grants',
  INVESTMENT = 'investments',
  POOLS = 'pools',
  SAFES = 'safes',
}

type ScenarioItem = {
  key: FundraisingScenarioKey;
} & (ExistingScenarioDetails | NewScenarioDetails);

export const fundraisingScenarioItems: ScenarioItem[] = [
  {
    key: FundraisingScenarioKey.POOLS,
    description: getTranslation('NEW_POOLS'),
    hoverText: <AppFormattedMessage id="POOLS_POPUP" />,
    title: <AppFormattedMessage id="POOLS" />,
    columns: [
      <AppFormattedMessage id="POOL_NAME" />,
      <AppFormattedMessage id="SCENARIO_FULLY_DILUTED_SHARES" />,
      <AppFormattedMessage id="SHARE_CLASS" />,
      <AppFormattedMessage id="DILUTION_IMPACT" />,
    ],
    columnsCount: 4,
    addButtonText: <AppFormattedMessage id="NEW_POOL" />,
    showButton: false,
  },
  {
    key: FundraisingScenarioKey.CUSTOM_SAFES,
    description: getTranslation('NEW_SAFES_FOR_CONVERSION'),
    hoverText: <AppFormattedMessage id="CUSTOM_SAFES_POPUP" />,
    title: toUpperCaseWords(getTranslation('NEW_SAFES_FOR_CONVERSION')),
    columns: [
      <AppFormattedMessage id="STAKEHOLDER" />,
      <AppFormattedMessage id="INVESTMENT" />,
      <AppFormattedMessage id="CAP" />,
      <AppFormattedMessage id="CAP_TYPE" />,
      <AppFormattedMessage id="DISCOUNT" />,
      <AppFormattedMessage id="FLOOR" />,
      <AppFormattedMessage id="SHARE_CLASS" />,
      <AppFormattedMessage id="CONVERTED" />,
      <AppFormattedMessage id="PERCENT_OWNER_AT_CONVR" />,
      <AppFormattedMessage id="PERCENT_POST_ROUND" />,
    ],
    columnsCount: 10,
    addButtonText: <AppFormattedMessage id="NEW_SAFES_FOR_CONVERSION" />,
    showButton: false,
  },
  {
    key: FundraisingScenarioKey.SAFES,
    description: getTranslation('AVAILABLE_SAFES'),
    hoverText: <AppFormattedMessage id="SAFES_POPUP" />,
    title: 'Existing SAFEs',
    columns: [
      <AppFormattedMessage id="STAKEHOLDER" />,
      <AppFormattedMessage id="INVESTMENT" />,
      <AppFormattedMessage id="VAL_CAP" />,
      <AppFormattedMessage id="CAP_TYPE" />,
      <AppFormattedMessage id="DISC" />,
      <AppFormattedMessage id="FLOOR" />,
      <AppFormattedMessage id="MATURITY_DATE" />,
      <AppFormattedMessage id="SHARE_CLASS" />,
      <AppFormattedMessage id="PERCENT_OWNER_AT_CONVR" />,
      <AppFormattedMessage id="PERCENT_POST_ROUND" />,
      <AppFormattedMessage id="CONVERTED" />,
    ],
    columnsCount: 11,
    showButton: true,
  },
  {
    key: FundraisingScenarioKey.INVESTMENT,
    description: getTranslation('NEW_INVESTMENTS'),
    hoverText: <AppFormattedMessage id="INVESTMENTS_POPUP" />,
    title: <AppFormattedMessage id="INVESTMENTS" />,
    columns: [
      <AppFormattedMessage id="STAKEHOLDER" />,
      <AppFormattedMessage id="INVESTMENT" />,
      <AppFormattedMessage id="SHARE_CLASS" />,
      <AppFormattedMessage id="NO_OF_SHARES" />,
      <AppFormattedMessage id="OWNERSHIP_PERCENTAGE" />,
    ],
    columnsCount: 5,
    addButtonText: <AppFormattedMessage id="NEW_INVESTMENT" />,
    showButton: false,
  },
  {
    key: FundraisingScenarioKey.GRANTS,
    description: getTranslation('AVAILABLE_GRANTS'),
    hoverText: <AppFormattedMessage id="GRANTS_POPUP" />,
    title: <AppFormattedMessage id="GRANTS" />,
    columns: [
      <AppFormattedMessage id="STAKEHOLDER" />,
      <AppFormattedMessage id="GRANT_ID" />,
      <AppFormattedMessage id="PLAN_TYPE" />,
      <AppFormattedMessage id="TOTAL_GRANTED" />,
      <AppFormattedMessage id="EXERCISABLE" />,
      <AppFormattedMessage id="SHARE_CLASS" />,
      <AppFormattedMessage id="CONVERSION" />,
      <AppFormattedMessage id="NO_OF_SHARES" />,
    ],
    columnsCount: 8,
    showButton: false,
    additionalColumns: [
      <AppFormattedMessage id="STAKEHOLDER" />,
      <AppFormattedMessage id="GRANT_ID" />,
      <AppFormattedMessage id="TOTAL_GRANTED" />,
      <AppFormattedMessage id="EXERCISABLE" />,
      <AppFormattedMessage id="SHARE_CLASS" />,
      <AppFormattedMessage id="CONVERSION" />,
      <AppFormattedMessage id="BASE_PRICE" />,
      <AppFormattedMessage id="PAYOUT" />,
      <AppFormattedMessage id="ISSUED_SHARES" />,
    ],
    additionalColumnsCount: 9,
  },
];
